module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2018 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2018")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("27 26 25 24 23 22 21 20 19 18    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-56357-2 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-56360-2 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226563602.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226563602.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Tunbridge, Laura, 1974– author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Singing in the age of anxiety : lieder performances in New York and London between the World Wars / Laura Tunbridge.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago ; London : The University of Chicago Press, 2018. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2017059451 | ISBN 9780226563572 (cloth : alk. paper) | ISBN 9780226563602 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Singing—New York (State)—New York—History—20th century. | Singing—England—London—History—20th century. | Songs, German—Social aspects. | Music—Social aspects. | Music—Performance—History—20th century. | World War, 1914–1918—Influence.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC ML2811.8.N48 T76 2018 | DDC 782.421680943/097471—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2017059451",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2017059451")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v("        This paper meets the requirements of ANSI"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v("NISO Z39.48–1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bf3b2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-tunbridge-0004.vue
// module id = 63
// module chunks = 0